module.exports = __webpack_public_path__ + "static/media/map_threat.bbd99654.png";